import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainPosPanelComponent } from './main-pos-panel/main-pos-panel.component';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  { path: '', component: MainPosPanelComponent,
    canActivate: [MsalGuard] },
  {
    path: 'detail',
    loadChildren: () =>
      import('./detail-pos/detail-pos.module').then((m) => m.DetailPosModule),
  },
  {
    path: 'not-found',
    loadChildren: () =>
      import('./not-found/not-found.module').then((m) => m.NotFoundModule),
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
